import styled from 'styled-components';
import {Row} from 'styled/common';

export const RowItem = styled(Row)`
  grid-column-gap: 20px;
  font-weight: 700;
  font-family: ${props => props.theme.fonts.fontFamily.body.font_name};
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontSecondary : '#152946'};
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;
`;

export const Text = styled.span`
  width: 100%;
`;
